import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicScriptInjector {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  loadAll(scriptUrls: string[]) {
    scriptUrls.map(script => this.load(script))
  }

  load(scriptUrl: string) {

    if (isPlatformBrowser(this.platformId)) {
      let node: any = document.createElement('script');
      node.src = scriptUrl;
      node.type = 'text/javascript';
      node.async = true;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }

  }

}
